/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: ZhangLei
 * @Date: 2020-08-13 13:56:13
 * @LastEditTime: 2020-08-13 13:56:52
 * @LastEditors: ZhangLei
 * @Description:
 * @FilePath: /desktop/src/service/menuService.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import request from "@/utils/request";
/**
 * Menu列表
 */
export function getMenuData(Info) {
  return request({
    url:
      "/api/v1/menus?size=" +
      Info.size +
      "&page=" +
      Info.page +
      "&filter=" +
      Info.filter +
      "&search=" +
      Info.search +
      "&order=" +
      Info.order,
    method: "GET"
  });
}
/*
 * 新建Menu页面数据
 */
export function createMenu(data) {
  return request({
    url: "/api/v1/menus",
    method: "POST",
    data: data
  });
}
/*
 * 编辑Menu页面数据
 */
export function editMenu(data) {
  return request({
    url: "/api/v1/menus/" + data.id,
    method: "PATCH",
    data: data.data
  });
}
/*
 * 获取Menu数据详情
 */
export function getMenuInfo(id) {
  return request({
    url: "/api/v1/menus/" + id,
    method: "GET"
  });
}
/*
 * 删除Menu数据
 */
export function deleteMenu(id) {
  return request({
    url: "/api/v1/menus/" + id,
    method: "DELETE"
  });
}



// WEBPACK FOOTER //
// ./src/service/menuService.js